import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { utils } from '@pixi/core';
import { convertToList } from '../utils/convertToList.mjs';
import { createStringVariations } from '../utils/createStringVariations.mjs';
import { isSingleItem } from '../utils/isSingleItem.mjs';
var Resolver = /*#__PURE__*/function () {
  function Resolver() {
    _classCallCheck(this, Resolver);
    this._assetMap = {};
    this._preferredOrder = [];
    this._parsers = [];
    this._resolverHash = {};
    this._bundles = {};
  }
  _createClass(Resolver, [{
    key: "prefer",
    value: function prefer() {
      var _this = this;
      for (var _len = arguments.length, preferOrders = new Array(_len), _key = 0; _key < _len; _key++) {
        preferOrders[_key] = arguments[_key];
      }
      preferOrders.forEach(function (prefer) {
        _this._preferredOrder.push(prefer);
        if (!prefer.priority) {
          prefer.priority = Object.keys(prefer.params);
        }
      });
      this._resolverHash = {};
    }
  }, {
    key: "basePath",
    get: function get() {
      return this._basePath;
    },
    set: function set(basePath) {
      this._basePath = basePath;
    }
  }, {
    key: "rootPath",
    get: function get() {
      return this._rootPath;
    },
    set: function set(rootPath) {
      this._rootPath = rootPath;
    }
  }, {
    key: "parsers",
    get: function get() {
      return this._parsers;
    }
  }, {
    key: "reset",
    value: function reset() {
      this._preferredOrder = [];
      this._resolverHash = {};
      this._assetMap = {};
      this._rootPath = null;
      this._basePath = null;
      this._manifest = null;
    }
  }, {
    key: "addManifest",
    value: function addManifest(manifest) {
      var _this2 = this;
      if (this._manifest) {
        console.warn("[Resolver] Manifest already exists, this will be overwritten");
      }
      this._manifest = manifest;
      manifest.bundles.forEach(function (bundle) {
        _this2.addBundle(bundle.name, bundle.assets);
      });
    }
  }, {
    key: "addBundle",
    value: function addBundle(bundleId, assets) {
      var _this3 = this;
      var assetNames = [];
      if (Array.isArray(assets)) {
        assets.forEach(function (asset) {
          if (typeof asset.name === "string") {
            assetNames.push(asset.name);
          } else {
            assetNames.push.apply(assetNames, _toConsumableArray(asset.name));
          }
          _this3.add(asset.name, asset.srcs);
        });
      } else {
        Object.keys(assets).forEach(function (key) {
          assetNames.push(key);
          _this3.add(key, assets[key]);
        });
      }
      this._bundles[bundleId] = assetNames;
    }
  }, {
    key: "add",
    value: function add(keysIn, assetsIn, data) {
      var _this4 = this;
      var keys = convertToList(keysIn);
      keys.forEach(function (key) {
        if (_this4._assetMap[key]) {
          console.warn("[Resolver] already has key: ".concat(key, " overwriting"));
        }
      });
      if (!Array.isArray(assetsIn)) {
        if (typeof assetsIn === "string") {
          assetsIn = createStringVariations(assetsIn);
        } else {
          assetsIn = [assetsIn];
        }
      }
      var assetMap = assetsIn.map(function (asset) {
        var _formattedAsset$data;
        var formattedAsset = asset;
        if (typeof asset === "string") {
          var parsed = false;
          for (var i = 0; i < _this4._parsers.length; i++) {
            var parser = _this4._parsers[i];
            if (parser.test(asset)) {
              formattedAsset = parser.parse(asset);
              parsed = true;
              break;
            }
          }
          if (!parsed) {
            formattedAsset = {
              src: asset
            };
          }
        }
        if (!formattedAsset.format) {
          formattedAsset.format = formattedAsset.src.split(".").pop();
        }
        if (!formattedAsset.alias) {
          formattedAsset.alias = keys;
        }
        if (_this4._basePath || _this4._rootPath) {
          formattedAsset.src = utils.path.toAbsolute(formattedAsset.src, _this4._basePath, _this4._rootPath);
        }
        formattedAsset.data = (_formattedAsset$data = formattedAsset.data) !== null && _formattedAsset$data !== void 0 ? _formattedAsset$data : data;
        return formattedAsset;
      });
      keys.forEach(function (key) {
        _this4._assetMap[key] = assetMap;
      });
    }
  }, {
    key: "resolveBundle",
    value: function resolveBundle(bundleIds) {
      var _this5 = this;
      var singleAsset = isSingleItem(bundleIds);
      bundleIds = convertToList(bundleIds);
      var out = {};
      bundleIds.forEach(function (bundleId) {
        var assetNames = _this5._bundles[bundleId];
        if (assetNames) {
          out[bundleId] = _this5.resolve(assetNames);
        }
      });
      return singleAsset ? out[bundleIds[0]] : out;
    }
  }, {
    key: "resolveUrl",
    value: function resolveUrl(key) {
      var result = this.resolve(key);
      if (typeof key !== "string") {
        var out = {};
        for (var i in result) {
          out[i] = result[i].src;
        }
        return out;
      }
      return result.src;
    }
  }, {
    key: "resolve",
    value: function resolve(keys) {
      var _this6 = this;
      var singleAsset = isSingleItem(keys);
      keys = convertToList(keys);
      var result = {};
      keys.forEach(function (key) {
        if (!_this6._resolverHash[key]) {
          if (_this6._assetMap[key]) {
            var _assets$;
            var assets = _this6._assetMap[key];
            var preferredOrder = _this6._getPreferredOrder(assets);
            var bestAsset = assets[0];
            preferredOrder === null || preferredOrder === void 0 ? void 0 : preferredOrder.priority.forEach(function (priorityKey) {
              preferredOrder.params[priorityKey].forEach(function (value) {
                var filteredAssets = assets.filter(function (asset) {
                  if (asset[priorityKey]) {
                    return asset[priorityKey] === value;
                  }
                  return false;
                });
                if (filteredAssets.length) {
                  assets = filteredAssets;
                }
              });
            });
            _this6._resolverHash[key] = (_assets$ = assets[0]) !== null && _assets$ !== void 0 ? _assets$ : bestAsset;
          } else {
            var src = key;
            if (_this6._basePath || _this6._rootPath) {
              src = utils.path.toAbsolute(src, _this6._basePath, _this6._rootPath);
            }
            _this6._resolverHash[key] = {
              src: src
            };
          }
        }
        result[key] = _this6._resolverHash[key];
      });
      return singleAsset ? result[keys[0]] : result;
    }
  }, {
    key: "_getPreferredOrder",
    value: function _getPreferredOrder(assets) {
      var _this7 = this;
      var _loop = function _loop() {
        var asset = assets[0];
        var preferred = _this7._preferredOrder.find(function (preference) {
          return preference.params.format.includes(asset.format);
        });
        if (preferred) {
          return {
            v: preferred
          };
        }
      };
      for (var i = 0; i < assets.length; i++) {
        var _ret = _loop();
        if (typeof _ret === "object") return _ret.v;
      }
      return this._preferredOrder[0];
    }
  }]);
  return Resolver;
}();
export { Resolver };